import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Markdown } from '../../../primitives/Markdown/index.js';
export const Text = ({
  content
}) => {
  return _jsx("div", {
    children: _jsx(Markdown, {
      value: content,
      isInline: true
    })
  });
};